export const searchNationalRegistry = (q, isCompany) => `/national-registry/search?q=${encodeURIComponent(q)}${isCompany === undefined ? '' : `&is_company=${isCompany}`}`;
